import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";

import { RowanTheme } from "./Theme";
import Header from "./Components/Header";

import Home from "./Routes/Home";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

function App() {
  const subDomain = window.location.hostname.split(".");

  if (subDomain[0] === "bsky") {
    window.location.replace("https://bsky.app/profile/rowanvr.games");
  }

  return (
    <ThemeProvider theme={RowanTheme}>
      <CssBaseline />
      <BrowserRouter>
        {/* <Header /> */}

        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
